import axiosClient from "./axiosClient";

const taxRateTypeApi = {
  getAll: () => {
    return axiosClient.get("/tax_rate_type/get-all", { withCredentials: true });
  },
};

export default taxRateTypeApi;
